import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchUserType = createAsyncThunk(
  'userType/fetchUserType',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetUserType();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: item.name,
          value: item.id,
          isDefaultValue: item.isDefaultValue,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  userTypeList: [],
  loading: false,
  error: '',
};

const userTypeSlice = createSlice({
  name: 'userType',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserType.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserType.fulfilled, (state, action) => {
        state.loading = false;
        state.userTypeList = action.payload;
        state.error = '';
      })
      .addCase(fetchUserType.rejected, (state, action) => {
        state.loading = false;
        state.userTypeList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default userTypeSlice.reducer;
